if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				item.querySelectorAll('.qty-button').forEach(btn => {
					btn.type = 'button';
				});

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 300));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			const liveForm = this.querySelector('form') || this.form;
			this.form = liveForm;
			if ( liveForm ) liveForm.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			let cartChanged = false;
			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body
				})
				.then(response => {
					if ( response.ok ) {
						cartChanged = true;
						return fetch(window.location.pathname + '?section_id=helper-cart&ga_cart=' + Date.now(), { cache: 'no-store' })
					} else {
						throw new Error('cart-change-failed');
					}
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const nextForm = sectionInnerHTML.querySelector('cart-form');
					const nextSubtotal = sectionInnerHTML.querySelector('[id="AjaxCartSubtotal"]');
					if ( ! nextForm || ! nextSubtotal ) throw new Error('cart-section-missing');

					const cartItems = this;
					cartItems.innerHTML = nextForm.innerHTML;
					cartItems.ajaxifyCartItems();

					const countEl = cartItems.querySelector('[data-cart-count]');
					const totalEl = cartItems.querySelector('[data-cart-total]');
					if ( countEl ) {
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = countEl.textContent;
						});
					}
					if ( totalEl ) {
						document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
							elm.textContent = totalEl.textContent;
						});
					}

					document.querySelectorAll('[id="AjaxCartSubtotal"]').forEach(elm => {
						elm.innerHTML = nextSubtotal.innerHTML;
					});

				})
				.catch(e => {
					console.log(e);
					if ( cartChanged ) {
						window.location.reload();
						return;
					}
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					const formNow = this.querySelector('form') || this.form;
					if ( formNow ) formNow.prepend(alert);
				})
				.finally(() => {
					const formNow = this.querySelector('form') || this.form;
					if ( formNow ) formNow.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			const minus = this.querySelector('.qty-minus');
			const plus = this.querySelector('.qty-plus');
			if ( minus ) {
				minus.type = 'button';
				minus.addEventListener('click', this.changeCartInput.bind(this));
			}
			if ( plus ) {
				plus.type = 'button';
				plus.addEventListener('click', this.changeCartInput.bind(this));
			}
		}
		changeCartInput(){
			setTimeout(()=>{
				const qty = this.querySelector('.qty');
				const item = this.closest('[data-js-cart-item]');
				const form = this.closest('cart-form');
				if ( ! qty || ! item || ! form || typeof form.updateCartQty !== 'function' ) return;
				const nextQty = parseInt(qty.value, 10);
				form.updateCartQty(item, isNaN(nextQty) ? 0 : nextQty);
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

if ( typeof CartProductRecommendations !== 'function' ) {

	class CartProductRecommendations extends HTMLElement {

		constructor(){
			super();
			this.generateRecommendations();
		}

		generateRecommendations(){
			const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
			if ( cartItems.length > 0 ) {
				fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=helper-cart-recommendations&product_id=${cartItems[0].dataset.productId}&limit=6`)
					.then(response => response.text())
					.then(text => {
						const innerHTML = new DOMParser()
	            .parseFromString(text, 'text/html')
	            .querySelector('.cart-product-recommendations');
	          if ( innerHTML && innerHTML.querySelectorAll('[data-js-recommended-item]').length > 0 ) {
	          	document.getElementById('cart-recommendations').innerHTML = innerHTML.innerHTML;
	          }
					})
			}
		}
	}

  if ( typeof customElements.get('cart-product-recommendations') == 'undefined' ) {
		customElements.define('cart-product-recommendations', CartProductRecommendations);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch(window.location.pathname + '?section_id=helper-cart&ga_cart=' + Date.now(), { cache: 'no-store' })
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const nextForm = sectionInnerHTML.querySelector('cart-form');
			const nextSubtotal = sectionInnerHTML.querySelector('[id="AjaxCartSubtotal"]');
			const cartItems = document.querySelector('cart-form');
			if ( ! nextForm || ! nextSubtotal || ! cartItems ) return;

			cartItems.innerHTML = nextForm.innerHTML;
			cartItems.ajaxifyCartItems();

			const countEl = cartItems.querySelector('[data-cart-count]');
			const totalEl = cartItems.querySelector('[data-cart-total]');
			if ( countEl ) {
				document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
					elm.textContent = countEl.textContent;
				});
			}
			if ( totalEl ) {
				document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
					elm.textContent = totalEl.textContent;
				});
			}

			document.querySelectorAll('[id="AjaxCartSubtotal"]').forEach(elm => {
				elm.innerHTML = nextSubtotal.innerHTML;
			});
			const sidebar = document.getElementById('site-cart-sidebar');
			if ( sidebar && typeof sidebar.show === 'function' ) sidebar.show();

		})

	}

}